export default [
  {
    path: '/productload',
    title: '产品介绍',
    component: () => import('@/views/production/ProductLoad.vue')
  },
  {
    path: '/selectProduct',
    title: '产品介绍',
    component: () => import('@/views/production/selectProduct.vue')
  },
  {
    path: '',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
    children: [
      {
        path: '',
        redirect: 'production'
      },

      {
        path: 'production',
        title: '产品信息',
        component: () => import('@/views/production/Production.vue'),
        meta: { title: '产品信息' },
        children: [

        ]
      },
      {
        path: 'version',
        title: '版本详情',
        component: () => import('@/views/version/Version.vue'),
        meta: { title: '版本详情' }
      },
      {
        path: 'equipment',
        title: '设备白名单',
        component: () => import('@/views/equipmentlist/EquipmentList.vue'),
        meta: { title: '设备白名单' }
      },

      {
        path: 'manage',
        title: '系统管理',
        component: () => import('@/views/system/System.vue'),
        meta: { title: '系统管理' },
        children: [
          {
            path: 'user',
            title: '用户管理',
            component: () => import('@/views/system/users/Users.vue'),
            meta: { title: '用户管理' }
          }
        ]
      }
    ]
  },
  // {
  //   path: 'productload',
  //   title: '产品介绍',
  //   component: () => import('@/views/production/ProductLoad.vue')
  // },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    hidden: true
  }
  // {
  //   path: '*',
  //   redirect: '/',
  //   hidden: true
  // }
]
